/* Fly the Mission — shared behaviors: reveal-on-scroll, counters, goal bar */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatNumber(n) {
    return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function animateCount(el) {
    var target = parseFloat(el.dataset.ftmCount || '0');
    var prefix = el.dataset.ftmPrefix || '';
    var suffix = el.dataset.ftmSuffix || '';
    if (reduceMotion || !target) {
      el.textContent = prefix + formatNumber(target) + suffix;
      return;
    }
    var duration = 1600;
    var start = null;
    function tick(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + formatNumber(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function activate(el) {
    el.classList.add('is-in');

    el.querySelectorAll('[data-ftm-count]').forEach(function (counter) {
      if (!counter.dataset.ftmCounted) {
        counter.dataset.ftmCounted = 'true';
        animateCount(counter);
      }
    });

    el.querySelectorAll('[data-ftm-progress]').forEach(function (bar) {
      var pct = Math.min(Math.max(parseFloat(bar.dataset.ftmProgress || '0'), 0), 100);
      requestAnimationFrame(function () {
        bar.style.width = pct + '%';
      });
    });
  }

  function init() {
    var targets = document.querySelectorAll('.ftm-reveal:not(.is-in)');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(activate);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            activate(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
